import {Component, output, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-dialog-rename",
    templateUrl: "./dialog-rename.component.html",
    styleUrls: ["./dialog-rename.component.scss"],
    imports: [MatInputModule, MatDialogContent, FormsModule, MatButtonModule, MatDialogActions, MatDialogTitle],
})
export class DialogRenameComponent {
    readonly $title = signal<string | undefined>(undefined)
    readonly onConfirm = output<string>()
    readonly dialogRef = inject(MatDialogRef<DialogRenameComponent>)
    readonly data = inject<Record<string, string>>(MAT_DIALOG_DATA)

    constructor() {
        this.$title.set(this.data.title)
    }

    confirm() {
        const title = this.$title()
        if (title !== undefined) {
            this.onConfirm.emit(title)
        }
        this.dialogRef.close(false)
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }
}
